// Mock data for Flourish High International
// This file contains all static content that can later be moved to backend/CMS

export const siteConfig = {
  company: {
    name: "Flourish High International",
    shortName: "FHI",
    email: "contact@flourishhigh.com",
    phones: {
      india: "+91 9131230076",
      newZealand: "+64 220856514"
    },
    tagline: "Rooted in India. Trading with the World.",
    description: "India-based International Trading Company",
    address: "Bhopal (MP), India - 462024",
    social: {
      linkedin: "https://linkedin.com/company/flourish-high-international", // Placeholder - update in UI
      instagram: "https://instagram.com/flourishhighinternational" // Placeholder - update in UI
    }
  },
  logos: {
    dark: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/mfz8aw28_FHI%20logo%20design%20-%20Hi%20Res%20%281%29.png",
    light: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/4kwejpuu_Flourish%20High%20Black%20Logo.png"
  }
};

export const heroContent = {
  headline: "Building Reliable Trade Bridges Between India and Global Markets",
  subtext: "Flourish High International works across handicrafts, home décor, textiles, agricultural products, and emerging sourcing categories through trusted supplier networks aligned with global buyer requirements.",
  ctas: [
  { id: 'cta-1', text: "Grow With FHI", href: "#contact", primary: true },
  { id: 'cta-2', text: "Discuss Your Sourcing Needs", href: "#contact", primary: false }],

  backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=1200&q=80" // Indian craftsmanship
};

export const aboutContent = {
  title: "About FHI",
  content: "Flourish High International is a global trading and sourcing company dedicated to connecting India\u2019s diverse ecosystem of manufacturers, suppliers, and artisans with international markets.\n\nWe work closely with a trusted network of partners across textiles, handicrafts, and agro products, enabling global buyers to access high-quality, competitively sourced products. Our approach combines deep local sourcing expertise with a strong understanding of international market expectations.\n\nAt Flourish High International, we focus on building transparent, reliable, and long-term trade relationships."
};

export const tradeFocus = [
{
  id: 1,
  title: "Textiles & Hospitality Linen",
  description: "We supply standardized export-quality towels, bed linen, pillow covers, floor mats, and kitchen textiles for hospitality, retail, and institutional buyers across global markets. These products offer consistent specifications, reliable sourcing, and scalable supply from India's leading textile clusters.",
  icon: "Layers",
  image: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/tvk4thlu_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2010_33_53%20AM.png"
},
{
  id: 2,
  title: "Indian Handicrafts & Home Décor",
  description: "We connect global buyers with curated handcrafted and functional décor products sourced from India's artisan clusters. Our focus combines traditional craftsmanship with contemporary designs suited for modern retail and lifestyle markets.",
  icon: "Palette",
  image: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/vtwwbui0_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2010_23_18%20AM.png"
},
{
  id: 3,
  title: "Custom Sourcing for Global Buyers",
  description: "Through our supplier network across India, we support tailored sourcing requirements including spices, paper and stationery products, carpets and rugs, select machinery, and other emerging trade categories based on buyer needs.",
  icon: "Globe",
  image: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/be6q0bez_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2010_18_01%20AM.png"
}];


export const craftHeritage = [
{
  id: 1,
  title: "Trusted Manufacturing Clusters",
  description: "We work with established production hubs across India for textiles, handicrafts, carpets, stationery products and emerging trade categories ensuring reliable quality, scalable supply and export readiness.",
  icon: "Network"
},
{
  id: 2,
  title: "Artisan Skill Meets Industrial Capability",
  description: "India offers a unique combination of traditional craftsmanship and modern manufacturing strength, enabling both handcrafted products and standardized export-quality goods for global markets.",
  icon: "Factory"
},
{
  id: 3,
  title: "Aligned With Global Buyer Expectations",
  description: "Our sourcing approach supports international buyers across Australia, New Zealand, Japan and other markets with consistent quality, structured sourcing and reliable supplier coordination.",
  icon: "PackageCheck"
}];


export const workProcess = [
{
  step: 1,
  title: "Understand buyer requirements",
  description: "We listen carefully to your needs and market specifications"
},
{
  step: 2,
  title: "Identify trusted suppliers",
  description: "Connect you with verified manufacturers and artisans"
},
{
  step: 3,
  title: "Sampling and commercial alignment",
  description: "Ensure product quality and pricing match expectations"
},
{
  step: 4,
  title: "Quality check and packaging",
  description: "Rigorous inspection before shipment preparation"
},
{
  step: 5,
  title: "Export documentation and shipping",
  description: "Complete logistics support for smooth international delivery"
}];


export const visionContent = {
  title: "Our Vision",
  content: "Flourish High International aims to build a future digital ecosystem connecting artisans, manufacturers, and global buyers. Our vision is to simplify international trade while helping Indian craftsmanship and products reach global markets. While that ecosystem evolves, FHI operates today as a trusted international sourcing and trade partner."
};

export const whyFHI = [
{
  id: 1,
  title: "Access to Reliable Indian Suppliers",
  description: "Curated network of verified manufacturers and artisans",
  icon: "Network"
},
{
  id: 2,
  title: "Strong Focus on Handicrafts",
  description: "Deep expertise in artisan products and traditional crafts",
  icon: "Award"
},
{
  id: 3,
  title: "Flexible Sourcing Across Industries",
  description: "Adaptable to diverse product categories and buyer needs",
  icon: "Layers"
},
{
  id: 4,
  title: "Transparent Communication",
  description: "Clear, honest dialogue throughout the trade process",
  icon: "MessageSquare"
},
{
  id: 5,
  title: "Quality Checks Before Shipment",
  description: "Rigorous inspection ensures product standards",
  icon: "CheckCircle"
},
{
  id: 6,
  title: "Long-term Partnership Mindset",
  description: "Building lasting relationships beyond single transactions",
  icon: "Handshake"
}];


export const faqData = [
{
  id: 1,
  question: "What products does FHI trade?",
  answer: "Flourish High International supports global buyers across multiple export-ready product categories from India. Our core focus includes textiles such as towels, bed linen, pillow covers and floor mats, along with Indian handicrafts and contemporary home décor products. We also supply carpets and rugs, paper and stationery products, and selected spices through verified supplier networks. In addition, we support custom sourcing requirements based on buyer specifications across emerging product categories."
},
{
  id: 2,
  question: "Do you manufacture products?",
  answer: "No, FHI is a trading and sourcing company. We connect global buyers with trusted Indian manufacturers and artisans who produce the products."
},
{
  id: 3,
  question: "Can you help source custom products?",
  answer: "Yes, absolutely. We work closely with buyers to understand their specific requirements and connect them with suppliers who can fulfill custom orders tailored to their markets."
},
{
  id: 4,
  question: "Do you support export logistics?",
  answer: "Yes, we provide complete export support including quality checks, packaging, documentation, and shipping coordination to ensure smooth international delivery."
},
{
  id: 5,
  question: "Who can contact FHI?",
  answer: "We welcome enquiries from importers, distributors, sourcing partners, retailers, and any business interested in Indian products or establishing trade relationships."
}];


// Production network carousel images
export const artisanImages = [
{
  id: 1,
  url: "https://images.unsplash.com/photo-1758269736002-71d2e00f6ba3?w=1200&q=80",
  alt: "Textile production in India's manufacturing clusters",
  caption: "Textile production in India's manufacturing clusters"
},
{
  id: 2,
  url: "https://images.unsplash.com/photo-1638310533874-6c124c012e1d?w=1200&q=80",
  alt: "Carpet weaving from established rug hubs",
  caption: "Carpet weaving from established rug hubs"
},
{
  id: 3,
  url: "https://images.unsplash.com/photo-1721508490084-1b1de5b230d4?w=1200&q=80",
  alt: "Woodcraft finishing from artisan regions",
  caption: "Woodcraft finishing from artisan regions"
},
{
  id: 4,
  url: "https://images.unsplash.com/photo-1727517786578-ff2bb896b852?w=1200&q=80",
  alt: "Paper and stationery production facilities",
  caption: "Paper and stationery production facilities"
},
{
  id: 5,
  url: "https://images.unsplash.com/photo-1771769606888-86e2f4c6c65e?w=1200&q=80",
  alt: "Spice processing and grading for export markets",
  caption: "Spice processing and grading for export markets"
},
{
  id: 6,
  url: "https://images.unsplash.com/photo-1663027592423-068f9b974a8c?w=1200&q=80",
  alt: "Traditional handicraft production",
  caption: "Traditional handicraft production"
}];


// About section background carousel images
export const aboutBackgroundImages = [
{
  id: 1,
  url: "https://images.unsplash.com/photo-1670121180583-39ab653a071c?w=1600&q=80",
  alt: "International cargo shipping",
  caption: "Global exports and logistics"
},
{
  id: 2,
  url: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/ef80m8m1_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2008_35_48%20AM.png",
  alt: "Global trade connectivity network centered on India",
  caption: "India's global trade connections"
},
{
  id: 3,
  url: "https://images.unsplash.com/photo-1689919902319-5163cc7369ff?w=1600&q=80",
  alt: "Luxury hotel textiles and linens",
  caption: "Premium textile exports"
},
{
  id: 4,
  url: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/wkdzrjw3_header-6.png",
  alt: "Indian artisan painting decorative pottery",
  caption: "Authentic handicraft artistry"
},
{
  id: 5,
  url: "https://customer-assets.emergentagent.com/job_global-artisan-hub-1/artifacts/6lq1q868_Gemini_Generated_Image_gj8nkpgj8nkpgj8n.png",
  alt: "Premium Indian handicrafts and home décor",
  caption: "Exquisite handcrafted products"
},
{
  id: 6,
  url: "https://images.pexels.com/photos/7869003/pexels-photo-7869003.jpeg?w=1600&q=80",
  alt: "Business collaboration",
  caption: "Strategic partnerships"
}];


// localStorage helper for contact form
export const saveContactFormData = (formData) => {
  try {
    const existingData = JSON.parse(localStorage.getItem('fhi_contact_submissions') || '[]');
    const newSubmission = {
      ...formData,
      id: Date.now(),
      timestamp: new Date().toISOString(),
      status: 'pending'
    };
    existingData.push(newSubmission);
    localStorage.setItem('fhi_contact_submissions', JSON.stringify(existingData));
    return { success: true, data: newSubmission };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getContactFormSubmissions = () => {
  try {
    return JSON.parse(localStorage.getItem('fhi_contact_submissions') || '[]');
  } catch (error) {
    return [];
  }
};